export default __webpack_public_path__ + "static/media/profile.a165f7bd.png";